import createSagaMiddleware from "redux-saga";
import { createLogger } from "redux-logger";
import saga from "./sagas";
import { rootReducer } from "./reducers";
import { configureStore } from "@reduxjs/toolkit";

// Creating Saga MiddleWare
const sagaMiddleware = createSagaMiddleware();

// Creating Logger
const logger = createLogger({
    collapsed: true,
    duration: true,

    predicate: () => process.env.REACT_APP_ENVIRONMENT === "LOCAL"

    /*return true for staging and local 
        return false for production*/
});

const middleware = [sagaMiddleware, logger];

export const store = configureStore({
    reducer: rootReducer,
    middleware: [...middleware],
    devTools: process.env.REACT_APP_ENVIRONMENT?.toLowerCase() === "local" && {
        stateSanitizer: () => {
            return {};
        },
        trace: true,
        traceLimit: 8,
        latency: 0,
        // No.of actions to show in the list
        maxAge: 35
    }
});

// Running the saga
sagaMiddleware.run(saga);
